import SvgImg from './SvgImg';

export default SvgImg;
